"use strict";
var Observable_1 = require('../../Observable');
var delay_1 = require('../../operator/delay');
Observable_1.Observable.prototype.delay = delay_1.delay;
//# sourceMappingURL=delay.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/add/operator/delay.js
// module id = 1080
// module chunks = 9